import React from 'react'
import BooksList from '../books/BooksList'
import { routeName } from '../../../../routes/routeName'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { useTranslation } from 'react-i18next'

type Props = {}

const JournalList = ({ }: Props) => {
    const { t } = useTranslation()
    return (
        <BooksList
            category_label={t("วารสาร")}
            category_path={routeName.e_library.journal}
            category_pathname_label={routeName.e_library.journal_list}
            library_category_name={ELibraryCategory.MAGAZINE}
            path_detail={routeName.e_library.journal_detail}
        />
    )
}

export default JournalList